import { Stack, Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { StatusTag, formatTimeSlots } from '@app/components';
import { IEmployeeDetailsSchema } from '../types';
import { CustomAvatar } from '@app/components/custom-avatar';

interface Props {
  row: IEmployeeDetailsSchema;
}

const EmployeeDetailsRow = (props: Props) => {
  const { row } = props;
  const actionTimeArray = Array.isArray(row?.actionTime)
    ? row?.actionTime
    : [row?.actionTime].filter(Boolean);
  const actionTime = formatTimeSlots(actionTimeArray);
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const actionBy = `${row.action?.firstName} ${row.action?.lastName}`;
  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.id ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <StatusTag status={row?.status ?? 'NA'} />
      </TableCellCustom>
      <TableCellCustom align="center" flex>
        <Typography variant="body2">{row?.reason ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex>
        <Stack
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '9px',
          }}
        >
          <CustomAvatar name={actionBy} color="info" />
          <Typography variant="body2">{actionBy ?? 'NA'}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{actionTime ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.interviewer ?? 'NA'}</Typography>
      </TableCellCustom>
    </>
  );
};

export { EmployeeDetailsRow };
